var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#4D4D4D",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38723_64689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4991 10.2175C27.3625 9.7087 27.0946 9.24468 26.7223 8.8719C26.35 8.49913 25.8863 8.23068 25.3777 8.09342C23.5054 7.58984 16 7.58984 16 7.58984C16 7.58984 8.49464 7.58984 6.62232 8.09074C6.11345 8.22756 5.64953 8.49586 5.27716 8.8687C4.90479 9.24154 4.63707 9.7058 4.50089 10.2148C4 12.0898 4 16.0006 4 16.0006C4 16.0006 4 19.9113 4.50089 21.7836C4.77679 22.8175 5.59107 23.6318 6.62232 23.9077C8.49464 24.4113 16 24.4113 16 24.4113C16 24.4113 23.5054 24.4113 25.3777 23.9077C26.4116 23.6318 27.2232 22.8175 27.4991 21.7836C28 19.9113 28 16.0006 28 16.0006C28 16.0006 28 12.0898 27.4991 10.2175ZM13.6161 19.5898V12.4113L19.8304 15.9738L13.6161 19.5898Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38723_64689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLightIcon);
export default __webpack_public_path__ + "static/media/youtube-light-icon.bd3688d06d0d97ee4521924d432e17ec.svg";
export { ForwardRef as ReactComponent };